export default __webpack_public_path__ + "static/media/Shonduras_BG_Mobile_Hi_Res.9b947053.jpg";